<template>
  <a-form-item>
    <template #label>
      <span v-if="!!label"> {{ label }} </span>
      <span v-else class="text--bold"> {{ item.title }} </span>
    </template>
    <a-select
      :getPopupContainer="(triggerNode) => triggerNode.parentNode"
      v-if="isText"
      mode="multiple"
      :value="item.values"
      show-arrow
      @change="handleChange"
    >
      <a-select-option v-for="value in item.available_values" :key="value">
        {{ value }}
      </a-select-option>
    </a-select>

    <a-row v-else :gutter="12">
      <a-col :span="12">
        Desde
        <a-input-number
          placeholder="0"
          class="input"
          @change="(value) => handleChange(value, 'range-start')"
        />
      </a-col>
      <a-col :span="12">
        Hasta
        <a-input-number
          placeholder="999999999"
          class="input"
          @change="(value) => handleChange(value, 'range-end')"
        />
      </a-col>
    </a-row>
  </a-form-item>
</template>

<script>
export default {
  props: {
    item: {
      required: true,
      type: Object,
    },
    label: {
      required: false,
      type: String,
      default: "",
    },
  },
  data: () => ({
    newRange: [],
  }),
  computed: {
    isText() {
      return this.item.type === "text";
    },
  },
  methods: {
    handleChange(value, key) {
      const newValue = key && key.includes("range") ? this.newRange : value;
      if (key === "range-start") this.newRange[0] = value;
      if (key === "range-end") this.newRange[1] = value;
      if (key && key.includes("range") && this.newRange[0] && this.newRange[1]) return;
      this.$emit("change", { title: this.item.title, value: newValue });
    },
  },
};
</script>

<style lang="sass" scoped>
.text
  padding: 12px 24px
  margin: 0

  &--bold
    color: $gray-9
    font-weight: 600

.input
  width: 100%

.ant-form-item
  margin-bottom: 4px
</style>
